export default __webpack_public_path__ + "static/media/transakLogo.0efc9c0b.svg";